import React, { Component } from "react";
import BigForm from "../../components/BigForm";
import { newPart } from "../../util/parts";
import "./NewPart.css";

class NewPart extends Component {
  constructor(props) {
    super(props);

    this.state = {
      name: "",
      sequence: "",
      type: "",
      err: null,
      success: false,
    };
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(event) {
    this.setState({ [event.target.name]: event.target.value });
  }

  handleSubmit(event) {
    event.preventDefault();
    const { name, sequence, type } = this.state;
    const data = {
      name,
      sequence,
      type,
    };
    const FD = new FormData();

    // Push our data into our FormData object
    Object.keys(data).forEach(key => FD.append(key, data[key]));

    newPart(FD)
      .then(() => this.setState({ err: null, success: true }))
      .catch(err => this.setState({ err: err.message }));
  }

  render() {
    return (
      <BigForm
        header="New Part"
        errorText={this.state.err || ""}
        successText={this.state.success ? "Part created!" : ""}
      >
        <form onSubmit={this.handleSubmit}>
          <div className="form-group">
            <label htmlFor="name">
              Name
              <input
                className="form-control"
                type="text"
                name="name"
                value={this.state.name}
                onChange={this.handleChange}
              />
            </label>
          </div>
          <div className="form-group">
            <label htmlFor="sequence">
              Sequence
              <textarea
                className="form-control"
                rows="3"
                name="sequence"
                value={this.state.sequence}
                onChange={this.handleChange}
              />
            </label>
          </div>
          <div className="form-group">
            <label htmlFor="type">
              Type
              <input
                className="form-control"
                type="text"
                name="type"
                value={this.state.type}
                onChange={this.handleChange}
              />
            </label>
          </div>
          <input type="submit" value="Create" />
        </form>
      </BigForm>
    );
  }
}

export default NewPart;



// WEBPACK FOOTER //
// ./src/pages/NewPart/NewPart.js